import { type Filters } from '../../../types';
import { type TripsContext } from '../types';

export const getFilters = (context: TripsContext): Filters => {
  const { endDate, jobType, port, startDate, tripType, vesselName } = context;
  return {
    endDate,
    jobType,
    port,
    startDate,
    tripType,
    vesselName,
  };
};
